import { Component, OnInit } from '@angular/core';
import { LocalizationService } from '../../shared/services/localization.service';
import { DashboardService } from '../../shared/services/dashboard.service';
import { ChartData, ChartType } from 'chart.js';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'njoy-detail-dashboard',
    templateUrl: './detail-dashboard.component.html',
    styleUrls: ['./detail-dashboard.component.css']
})
export class DetailDashboardComponent implements OnInit {

    doughnutChartData: ChartData<'doughnut'> = {
        labels: ['18-24', '25-40', '41+'],
        datasets: [
            { data: [55, 25, 20] }
        ]
    };
    doughnutChartType: ChartType = 'doughnut';

    private charteName;

    constructor(private route: ActivatedRoute,
        private localizationService: LocalizationService,
        private dashboardService: DashboardService) {
    }

    ngOnInit(): void {
        this.charteName = this.route.snapshot.paramMap.get('chartName');
        if (this.charteName === 'customer-details') {
            this.fetchCustomerChartsData();
        } else if (this.charteName === 'scan-details') {
            this.fetchScanChartsData();
        }

    }

    private fetchCustomerChartsData() {
        this.dashboardService.getDetailCustomerChartInformations().subscribe((data: any) => {
            const values = [];
            values.push(data.lessThanTwentyFive);
            values.push(data.lessThanFourty);
            values.push(data.olderThanFourty);
            this.doughnutChartData = {
                ...this.doughnutChartData,
                datasets: [{ data: values }]
            };
        });
    }

    private fetchScanChartsData() {
        this.dashboardService.getDetailScanChartInformations().subscribe((data: any) => {
            const values = [];
            values.push(data.lessThanTwentyFive);
            values.push(data.lessThanFourty);
            values.push(data.olderThanFourty);
            this.doughnutChartData = {
                ...this.doughnutChartData,
                datasets: [{ data: values }]
            };
        });
    }
}
